import { TFunction } from "i18next";
import { Text } from "@pentabd/ui";

export const Column = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 2,
      key: "id",
      name: "ক্র: নং",
      render: (id: number) => (
        <Text color="subtitle1" className="text-nowrap">
          {id}
        </Text>
      ),
    },
    {
      id: 3,
      key: "code",
      name: "আইডি নম্বর",
      render: (code: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {code}
        </Text>
      ),
    },
    {
      id: 4,
      key: "nameBn",
      name: "কর্মকর্তা/কর্মচারীর নাম",
      render: (nameBn: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {nameBn}
        </Text>
      ),
    },
    {
      id: 9,
      key: "positionNameBn",
      name: "পদবি",
      render: (positionNameBn: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {positionNameBn}
        </Text>
      ),
    },
    {
      id: 5,
      key: "memorialNo",
      name: "স্মারক নং ও তারিখ",
      render: (_: any, row: any) => (
        <Text color="subtitle1" className="text-nowrap">
          {`${row?.memorialNo || ""}  (${row?.date})`}
        </Text>
      ),
    },
    {
      id: 6,
      key: "description",
      name: "যে কারণে পুরস্কার প্রদান করা হয়েছে",
      render: (description: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {description}
        </Text>
      ),
    },
    {
      id: 7,
      key: "awardTitle",
      name: "পুরস্কারের বিবরণ",
      render: (awardTitle: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {awardTitle}
        </Text>
      ),
    },
    {
      id: 8,
      key: "id",
      name: "মন্তব্য",
      render: () => <Text color="subtitle1" className="text-nowrap"></Text>,
    },
  ];
};
